import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpiritionWithLoad } from "../../components/general/general-component/abstruct-component/useExpirition";
import * as types from "../ActionType";
import axios from "axios";
const END_POINT = process.env.REACT_APP_BASE_URL_PERMISSIONS;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}


export const loadProfileDetails = (navigate) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/auth/profile-details`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_PROFILE_DETAILS));
            }
        }).catch((err) => {
            console.log(err)
            //notifyError(err.response.data.message)
            hasExpiritionWithLoad(err.response.data.returnedCode,navigate)
        })
    }
}


export const editProfile = (name,email,old_password,new_password,new_password_confirmation,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const formValues = {
            name: name,
            email:email,
            role: "manager"
        };
        if(old_password !== '' && new_password !== '' && new_password_confirmation !==''){
            formValues.old_password = old_password;
            formValues.new_password = new_password
            formValues.new_password_confirmation = new_password_confirmation
        }
        axios.put(`${END_POINT}/api/auth/profile-update`,formValues, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_PROFILE_DETAILS));
                dispatch(loadProfileDetails());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            console.log(err)
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}



